import { Typography } from '@mui/material'
import Link from '../navigation/Link'
import { textOperators, dateOperators } from '../../utils/constants/operators'
import { buildStatusColumn } from '../fields/StatusField'
import ListModule from '../module/ListModule'
import React from 'react'
import DocumentPreview from '../document/DocumentPreview'
import Invoice from '../modules/Invoices/Invoice'

const InvoiceSubModule = ({ userRight, user, location, statusList }) => {
  const customerId = location?.state?.id ?? null

  const options = {
    tableStyle: { maxHeight: 350, padding: '1px' },
    paperStyle: {},
    accessRight: userRight,
    actions: { go: true },
    objectType: 'invoices',
    objectFilter: () => ({ customer_id: customerId, company_id: user.company_id }),
    isFilter: true,
    isExpand: true,
    defaultSorted: 'invoice_number',
    expand: (row) => <DocumentPreview Component={Invoice} document={row} />,
    columns: [
      {
        name: 'invoice_number',
        label: 'N° Facture',
        isFilter: true,
        operators: textOperators,
        mapping: (id, rowid) => (
          <Typography component='span'>
            <Link to={`/invoices/view`} state={{ id: rowid.id, history: '/customers/view' }}>
              {id}
            </Link>
          </Typography>
        )
      },
      {
        name: 'invoice_date',
        label: 'Date Facture',
        isFilter: true,
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY',
        operators: dateOperators
      },
      { name: 'total_amount_net', label: 'Montant total', type: 'currency', isFilter: false },
      buildStatusColumn('invoices', statusList)
    ]
  }

  const toolbar = {
    isFilter: true,
    columns: options.columns,
    isSubMod: true,
    style: { marginTop: '5px', marginBottom: '5px' },
    objectType: 'invoices',
    accessRight: userRight,
    actions: { addFor: true },
    getContext: () => ({ customer_id: customerId }),
    columnVisibility: true
  }

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(InvoiceSubModule)
